import './ProductsA.scss';

import { b2x } from '@b2x/react/src';

import { Button } from '../Button';
import { Container } from '../Container';
import { Icon, isIconName } from '../Icon';
import { ProductTile } from '../ProductTile';

export interface ProductsAContentType {
  mainComponent?: boolean;
  products?: b2x.contentTypes.ContentSectionList<{
    id: string;
  }>;
  title?: string;
}

interface ProductsAProps extends ProductsAContentType {}

export const ProductsA = ({ mainComponent, products, title }: ProductsAProps) => {
  return (
    <b2x.Div className="products-a position-relative">
      <Container fluid="always">
        <b2x.Div background="#FFFFFF" className="overflow-hidden" paddingX={3} paddingY={{ lg: 5, xs: 3 }}>
          <b2x.Div className="title-container" marginBottom={{ lg: 4, xs: 2 }} textAlign={'center'}>
            <b2x.ConditionalWrapper
              condition={title !== undefined}
              wrapper={
                mainComponent ? (
                  <b2x.H1 className="title" fontWeight={700} margin={0} />
                ) : (
                  <b2x.P className="title" fontWeight={700} margin={0} />
                )
              }
            >
              {b2x.formatHtml(title)}
            </b2x.ConditionalWrapper>
          </b2x.Div>
          <b2x.Div className="product-container px-lg-5">
            {products && products.length > 0 && (
              <b2x.ProductsByIds ids={products.map(({ id }) => id)}>
                {(_products) => (
                  <b2x.EqualHeight>
                    <b2x.Listing name="Products A" products={_products}>
                      <b2x.SwiperContext>
                        {({ navigationNextElRef, navigationPrevElRef, swiper }) => (
                          <>
                            <b2x.Swiper
                              breakpoints={{
                                lg: {
                                  slidesPerView: 4,
                                },
                                md: {
                                  slidesPerView: 2.25,
                                },
                                xs: {
                                  slidesPerView: 1.15,
                                },
                              }}
                              centerInsufficientSlides
                              navigation={{ custom: true }}
                              slides={_products?.map((product) => (
                                <ProductTile key={product.id} product={product} />
                              ))}
                              spaceBetween={10}
                              watchSlidesProgress
                            ></b2x.Swiper>
                            <div className="slider-button-wrapper position-absolute d-flex align-items-center justify-content-between">
                              {b2x.appConfig.icons?.slider?.arrow?.left &&
                                isIconName(b2x.appConfig.icons.slider.arrow.left) && (
                                  <Button className="slider-button-prev" innerRef={navigationPrevElRef} variant="blank">
                                    <Icon
                                      className="slider-arrow-right text-dark"
                                      name={b2x.appConfig.icons.slider.arrow.left}
                                      size={40}
                                    />
                                  </Button>
                                )}

                              {b2x.appConfig.icons?.slider?.arrow?.right &&
                                isIconName(b2x.appConfig.icons.slider.arrow.right) && (
                                  <Button className="slider-button-next" innerRef={navigationNextElRef} variant="blank">
                                    <Icon
                                      className="slider-arrow-right text-dark"
                                      name={b2x.appConfig.icons.slider.arrow.right}
                                      size={40}
                                    />
                                  </Button>
                                )}
                            </div>
                          </>
                        )}
                      </b2x.SwiperContext>
                    </b2x.Listing>
                  </b2x.EqualHeight>
                )}
              </b2x.ProductsByIds>
            )}
          </b2x.Div>
        </b2x.Div>
      </Container>
    </b2x.Div>
  );
};
